import { configureStore } from '@reduxjs/toolkit';
import mapReducer from './components/map/mapSlice';
import mapUiReducer from './components/map/mapUiSlice';
import exportReducer from './components/map/export/exportSlice';
import authReducer from './store/authSlice';
import eventsReducer from './store/eventsSlice';
import orbatReducer from './store/orbatSlice';
import markersReducer from './store/markersSlice';
import graphicsReducer from './store/graphicsSlice';
import mapBundleReducer from './store/mapBundleSlice';
import clientsReducer from './store/clientsSlice';
import accountsReducer from './store/accountsSlice';
import usersReducer from './store/usersSlice';

export const store = configureStore({
    reducer: {
        map: mapReducer,
        mapUi: mapUiReducer,
        export: exportReducer,
        auth: authReducer,
        events: eventsReducer,
        orbat: orbatReducer,
        markers: markersReducer,
        graphics: graphicsReducer,
        mapBundle: mapBundleReducer,
        clients: clientsReducer,
        accounts: accountsReducer,
        users: usersReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;